export class HistoricalVolatilityData {
    lastPrice: number;
    lvl1Left: number;
    lvl1Right: number;
    lvl2Left: number;
    lvl2Right: number;
}
